import React from "react";
import { Box, Grid, Container, Typography } from "@mui/material";
import { facebook, insta, linkdin, loginPage1, twitter } from "../iconsImports";
import { useNavigate } from "react-router-dom";
import {
  getFirmAddress,
  getFirmContact,
  getFirmEmail,
} from "../theme/setThemeColor";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#f6f3f3",
        py: 4,
        position: "relative",
        textAlign: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: `url(${loginPage1})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "650px", // Large watermark
          opacity: 0.08, // Subtle watermark effect
          top: 0,
          left: 0,
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} justifyContent="space-between">
          {/* Left Section */}
          <Grid item xs={12} md={5} textAlign="left">
            <Box>
              <img
                src={loginPage1}
                alt="logo"
                width="200px"
                style={{
                  borderRadius: "6px",
                  padding: "4px",
                }}
              />
              <Typography variant="body1" sx={{ mt: 2, color: "#555" }}>
                {getFirmAddress()}
              </Typography>
            </Box>

            {/* Social Media Icons */}
            <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
              {[facebook, linkdin, twitter, insta].map((icon, idx) => (
                <img
                  key={idx}
                  src={icon}
                  alt="social"
                  width="36px"
                  height="36px"
                  style={{
                    borderRadius: "50%",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.1)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              ))}
            </Box>
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={7} sx={{ mt: 1 }}>
            <Grid container spacing={4}>
              {/* Company Section */}
              <Grid item xs={12} sm={3}>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                >
                  Company
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => navigate("/")}
                  sx={{ cursor: "pointer" }}
                >
                  Home
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => navigate("/about-us")}
                  sx={{ cursor: "pointer" }}
                >
                  About Us
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => navigate("/contact-us")}
                  sx={{ cursor: "pointer" }}
                >
                  Contact Us
                </Typography>
              </Grid>
   {/* services */}
   <Grid item xs={12} sm={3}>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                >
                  Services
                </Typography>
                {/* <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageDmt")}
                  sx={{ cursor: "pointer" }}
                >
                  DMT
                </Typography> */}
                <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageAeps")}
                  sx={{ cursor: "pointer" }}
                >
Aeps                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageCms")}
                  sx={{ cursor: "pointer" }}
                >
CMS 
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageRecharge")}
                  sx={{ cursor: "pointer" }}
                >
Recharge 
                </Typography>
                {/* <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageUpi")}
                  sx={{ cursor: "pointer" }}
                >
Upi 
                </Typography> */}
                <Typography
                  className="text-style"
                  onClick={() => navigate("/LandingPageBbps")}
                  sx={{ cursor: "pointer" }}
                >
BBPS 
                </Typography>
                {/* <Typography
                  className="text-style"
                  onClick={() => navigate("/our-services")}
                  sx={{ cursor: "pointer" }}
                >
Payments 
                </Typography> */}
              </Grid>
              {/* Policies Section */}
              <Grid item xs={12} sm={3}>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                >
                  Policies
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => window.open("/terms-conditions", "_blank")}
                  sx={{ cursor: "pointer" }}
                >
                  Terms & Conditions
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => window.open("/privacy-policy", "_blank")}
                  sx={{ cursor: "pointer" }}
                >
                  Privacy Policy
                </Typography>
                <Typography
                  className="text-style"
                  onClick={() => window.open("/refund-policy", "_blank")}
                  sx={{ cursor: "pointer" }}
                >
                  Refund Policy
                </Typography>
              </Grid>

              {/* Contact Us Section */}
              <Grid item xs={12} sm={3}>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "left", fontWeight: "bold", mb: 2 }}
                >
                  Contact Us
                </Typography>
                <Typography sx={{ textAlign: "left" }}>
                  {getFirmContact()}
                </Typography>
                <Typography sx={{ textAlign: "left" }}>
                  {getFirmEmail()}
                </Typography>
              </Grid>
           
            </Grid>

           
            <Grid item xs={12} sx={{ mt: 4, textAlign: { xs: "center", md: "left" } }}>
              <Typography sx={{ color: "#000", fontSize: "16px" }}>
                © Copyright 2024 DILLIPAY TECHNOLOGIES LIMITED. All Rights Reserved.
              </Typography>
              <Typography sx={{ color: "#000", fontSize: "16px" }}>
                Disclaimer: Any dispute arising shall be subject to the jurisdiction of the courts of Delhi.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
